// extracted by mini-css-extract-plugin
export default {"variants":"ContentTestReport_variants__wl2Li","check":"ContentTestReport_check__Lk+zD"};